export const logoIpsumIconStyle = (isActive: boolean) => {
  if (isActive) {
    return "#640EF1"
  }
  return "#080C2E"
}
